import { AllWords } from '../AllWords';

export function isActualWord(word) {
    return AllWords.Words.includes(word);
}